import img1 from "../../../Assets/Industies/industries1.png";
import img2 from "../../../Assets/Industies/industries2.png";
import img3 from "../../../Assets/Industies/industries3.png";
import img4 from "../../../Assets/Industies/industries4.png";

// industriesData.js
const industriesData = [
  {
    title: "Life sciences & Biotech",
    img: img1,
    slug: "life-sciences-biotech",
    description: [
      "We build specialized  technology systems and dashboards that streamline laboratory operations, research workflows, and data management.  ",
      "Our solutions include Laboratory Information Management Systems (LIMS), Electronic Lab Notebooks (ELN), clinical data platforms, and bioinformatics tools designed to handle complex scientific data. We integrate lab instruments, automate sample tracking, and enable secure, compliant data storage. ",
      "Using AI-driven research analytics and cloud-based infrastructure, we help biotech organizations accelerate discovery, improve data accuracy, and maintain regulatory compliance. ",
    ],
    impact: [
      "Faster research cycles ",
      "Improved lab efficiency",
      "Accurate and traceable data management ",
      "Scalable research infrastructure  ",
    ],
  },
  {
    title: "Construction & Civil Engineering ",
    img: img2,
    slug: "construction-civil-engineering",
    description: [
      "We deliver construction technology solutions that provide real-time visibility into projects, resources, and site operations. ",
      "Our systems include BIM integration, project planning tools, site monitoring dashboards, equipment tracking, and construction analytics platforms. We connect field data with centralized dashboards to enable better decision-making.",
      "Through IoT-based monitoring, energy tracking, and predictive maintenance systems, we help construction companies reduce delays, optimize resource usage, and control costs. ",
    ],
    impact: [
      "Reduced project delays  ",
      "Real-time site visibility ",
      "Optimized equipment utilization ",
      "Lower operational and energy costs  ",
    ],
  },
  {
    title: "Manufacturing & Industry 4.0 ",
    img: img3,
    slug: "manufacturing-industry",
    description: [
      "We build smart manufacturing systems that digitize production, improve efficiency, and enable data-driven operations. ",
      "Our solutions include production planning & scheduling systems, ERP integrations, IoT-enabled shop floor monitoring, predictive maintenance platforms, and industrial analytics dashboards.",
      "Using Industry 4.0 technologies, AI, and real-time data processing, we help manufacturers optimize throughput, reduce downtime, and improve quality control. ",
    ],
    impact: [
      "Increased production efficiency ",
      "Reduced machine downtime ",
      "Data-driven decision making ",
      "Scalable and connected factory operations ",
    ],
  },
  {
    title: "Supply Chain & Logistics ",
    img: img4,
    slug: "supply-chain-logistics",
    description: [
      "We develop intelligent supply chain systems that provide end-to-end visibility and operational control.  ",
      "Our offerings include Warehouse Management Systems (WMS), Transportation Management Systems (TMS), route optimization tools, inventory analytics, and demand forecasting platforms. ",
      "By implementing real-time tracking, predictive analytics, and automation, we help businesses streamline logistics operations, reduce costs, and improve delivery performance. ",
    ],
    impact: [
      "Faster and more efficient logistics ",
      "Optimized inventory management ",
      "Reduced transportation costs r",
      "Improved demand forecasting accuracy ",
    ],
  },
];

export default industriesData;
